import { PropsWithChildren } from 'react';

export const RouterWrapper: React.FC<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  const hasMain = location.pathname.includes('/lp/');
  return hasMain ? <div>{children}</div> : <main>{children}</main>;
};
